import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { TripMetadata } from '../_models/driver-data';
import { DocumentsService } from '../_services/documents.service';
import { DynamicTableService } from '../_services/dynamic-table.service';
import { PdfService } from '../_services/pdf.service';
import moment from 'moment';
import { FilterService } from '../_services/filter.service';
import { Sign } from '../_models/sign';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../_services/app.service';
import { AuthService } from '../_services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DriverSignerService } from '../_services/driver-signer.service';
import { ErrorDiagnosticService } from '../_services/error-diagnostic.service';
import { TypeEntity } from '../shared/enums/type-entity';

@Component({
  standalone: false,
  selector: 'app-driver-signer',
  templateUrl: './driver-signer.component.html',
  styleUrls: ['./driver-signer.component.scss']
})

export class DriverSignerComponent implements OnInit {
//---------------------//
//    Declaraciones    //
//---------------------//
  // objetos //
  currentSign;
  columnsConfig$;
  driverSignerData: TripMetadata;

  // listas //
  documents = [];
  signList: Array<Sign> = [];
  gridFilter = [];
  pdfs = [];

  // booleanos //
  signed: boolean = false;
  onPreview: boolean = false;
  postSign: boolean = false;
  sending: boolean = false;
  signAllPages: boolean = false;
  loading: boolean = false;
  errorview: boolean = false;
  lockedview: boolean = false;
  isTenarisDestination: boolean = false;
  externalPostSign: boolean = false;

  // propiedades //
  tripnumber: string = '';
  pdfToPrint: string = '';
  typeEntityFilter;

  // child //
  @ViewChild('mailSender', { static: true }) mailSender;
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;
  @ViewChild('iframe', { static: true }) iframe: ElementRef;

  constructor(
    public authService: AuthService,
    private renderer: Renderer2,
    private appService: AppService,
    private modalService: NgbModal,
    private filterService: FilterService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private pdfService: PdfService,
    private documentsService: DocumentsService,
    private dynamicTableService: DynamicTableService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private driverSignerService: DriverSignerService,
    private errorDiagnosticService: ErrorDiagnosticService,
  ) { }

  ngOnInit(): void {
      // Inicio de datos    
      this.initData();
      // Bloque Grilla
      this.initGridFilter();
  }

  ngOnChange(): void{
      // Inicio de datos    
      this.initData();
      // Bloque Grilla
      this.initGridFilter();
  }

  initData() {
    // Obtengo uuid desde la URL
    var encripteduuid = this.route.snapshot.paramMap.get('guid');
    
    return new Promise((resolve, reject) => {
      // Armado de Description y Documentos a partir del uuid
      this.driverSignerService.getTripData(encripteduuid).subscribe(data => {
        // Bloque description y documentos
        this.setData(data);
        
        //// Obtencion de pdfs
        this.documentsService.getSicramDocumentsPdf(true, false, encripteduuid).subscribe(async data => {
          // Filtro Fields por TypeEntity según si, dentro de DriverSigner, es firma Driver, o es firma ExternalDestiny'
          if(data[0].Status == 1) this.postSign = true;

          if(!this.postSign){
            this.typeEntityFilter = TypeEntity.DriverSign;
          }
          else{
            if(!this.isTenarisDestination && !this.externalPostSign){
              this.typeEntityFilter = TypeEntity.SignDestiny;
            }
          } 
          
          data.forEach(doc => {
            if(doc.SignType == null) return;
            doc.SignType.Fields = doc.SignType.Fields.filter(d => d.TypeEntity && d.TypeEntity == this.typeEntityFilter);
          })

          data.forEach(doc => Object.assign(doc, { pdfPreview: doc.pdf.slice(0) }));
          this.pdfs = data
          await this.pdfService.searchCoordinates(this.pdfs);
          this.renderFields(data);
          // Verifica si estan firmados
          this.isSignedDocs();
          resolve(true);
        }, err => {
          this.toastr.error(this.translateService.instant('sign.pdf_get_error'));
          reject();
        });
      }, err => {
        if(this.isDriverDocumentLocked(err)){
          this.lockedview = true; 
        }
        else{
          this.errorview = true;
        }
      });
    })
  }

  initGridFilter() {
    this.authService.getProfileDriver().subscribe(data => {
    }, err => {
      this.toastr.error(err, this.translateService.instant('error.title'));
    })

    this.columnsConfig$ = this.dynamicTableService.tableColumns$.pipe(map(data => {
      if(data != undefined){
        return data.filter(d => this.gridFilter.includes(d.name.toLowerCase()));
      }
    }));
    //Podría obtenerse desde un servicio o filtro para que sea dinamico.
    this.gridFilter = ['order','documenttype'] 
  }

  setData(data: TripMetadata){
    this.driverSignerData = data;
    this.documents = data.documents;
    this.documentsService.initDocuments(this.documents);
    this.driverSignerService.documentsLocation = data.location;
    this.driverSignerService.documentsYard = this.documents[0].Yard.toLowerCase();
    this.isTenarisDestination = data.isTenarisDestination;
    this.externalPostSign = data.externalPostSign;
  }

  createSign(content, current) {
    this.signed = false;
    this.currentSign = current; //currentsign.type
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  async checkAndSign(){
      this.spinner.show();
      if (this.signList.filter(x => x.type == 'nominate').length > 0) {
        this.checkDocSigners();
      }
      
      if(this.postSign && !this.isTenarisDestination){
        this.signExternal().then();
      }
      else{
        this.stampAndSendPdf().then();
      }
  }

  async stampAndSendPdf() {
    return new Promise((resolve, reject) => {
      // Se agrega automaticamente el nombre del Driver (En el sitio web esto se ingresa desde un campo)
      this.signList.find(x => x.type == 'driver').printName = this.driverSignerData.driverName;

      let isNominateSign = this.signList.filter(x => x.type == 'nominate').length > 0;

      //Agrego el la estampa de origen al signList para stampSignature
      this.driverSignerService.getDriverStamp()
      .then(async stampImg => {

        const driverOriginStamp : Sign = {
          contentType: 'image/png',
          isRequiredPrintName: false,
          isRequiredSign : false,
          printName: '',
          showDate: false,
          showPrintName: false,
          showSign: false,
          sign: stampImg,
          subType: '',
          type: 'stamp',
        }

        this.signList.push(driverOriginStamp);
        
        this.pdfService.stampSignatures(this.pdfs, this.signList, isNominateSign, false, true)
        .then(signedPdfs => {
          signedPdfs.forEach(sign => {
            let document = this.pdfs.find(doc => doc.docId === sign.docId);
            if (document) {
              document.pdf = sign.pdf;
              document.pdfPreview = sign.pdf.slice(0);
            }
          });
          // this.spinner.hide();
          this.onPreview = true;
          this.sendSignedDocs();
          resolve(true);
        })
        .catch(err => {
          this.spinner.hide();
          this.toastr.error(this.translateService.instant('sign.pdf_sign_error'));
          reject();
          throw Error(err);
        });
      });
    })
  }

  async signExternal() {
    return new Promise((resolve, reject) => {
      let isNominateSign = this.signList.filter(x => x.type == 'nominate').length > 0;
      this.pdfService.stampSignatures(this.pdfs, this.signList, isNominateSign, false, true)
      .then(signedPdfs => {
        signedPdfs.forEach(sign => {
          let document = this.pdfs.find(doc => doc.docId === sign.docId);
          if (document) {
            document.pdf = sign.pdf;
          }
          resolve(true);
        });
        this.onPreview = true;
        this.sendSignedDocs();
        this.externalPostSign = true;
      })
      .catch(err => {
        this.spinner.hide();
        this.toastr.error(this.translateService.instant('sign.pdf_sign_error'));
        reject();
        throw Error(err);
      });
    })
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    const binary = String.fromCharCode(...new Uint8Array(buffer));
    return btoa(binary);
  }

  checkDocSigners(onSend: boolean = false) {
    return new Promise((resolve, reject) => {
      const checked = this.documentsService.getDocumentsValue().filter(d => d.checked).map(d => d.Id);

      let requestConfig = this.filterService.getFiltersRequest();
      if (!requestConfig) {
        requestConfig = {
          ...requestConfig, ...{
            filters: [],
            fromDate: moment().format(),
            signed: 0,
            toDate: moment().format(),
            scan: ""
          }
        };
      }
      this.documentsService.getDocuments(requestConfig).subscribe(async data => {
        if (checked.length > 0) {
          checked.forEach(id => {
            const document = data.find(d => d.Id === id);
            if (document) document.checked = true;
          });
        }

        if (this.documents[0].Signers.filter(s => s.Status.toLowerCase() === 'signed').length < data[0]['Signers'].filter(s => s.Status.toLowerCase() === 'signed').length) {
          this.documents = data;
          this.initData().then(async data => {
            if (onSend) {
              await this.stampAndSendPdf();
            }
            resolve(true);
          });
        }
        else {
          resolve(true);
        }
      },
        err => {
          reject();
        });
    })
  }

  isSignedDocs() {
    this.postSign = !this.documents.filter(d => !d.Signed).length;
  }

  canSignAllPages(){    
    this.signAllPages = false;
  }

  async signDocuments(data: Sign) { // Aca mismo se recibe la firma, se estampa en el documento, se recupera la estampa y se muestra la vista de doc firmado
    this.spinner.show();
    var index = this.signList.findIndex(x => (x.type == data.type) );
  
    if(index >= 0) {
      this.signList[index].sign =  data.sign;
      this.signList[index].subType =  data.subType;
      this.signList[index].contentType = data.contentType;
    }

    await this.checkAndSign()

  }

  download(docs: any[] = []) {
    if (!!docs.length) {
      this.getDownloadDoc();
      return;
    }

    const pdfs = this.filterSigned('download');
    if (!!!pdfs.length) return;
    this.getDownloadDoc();
  }
  
  getDownloadDoc() {
    this.errorDiagnosticService.setMethodName('SignComponent.getDownloadDoc()');
    const encryptedGuid = this.route.snapshot.paramMap.get('guid');
    this.documentsService.getSicramDocumentsPdf(false, true, encryptedGuid).subscribe(async data => {
        this.pdfService.downloadPdfs(data);
    }, err => {
      if (this.isDriverDocumentLocked(err)) {
        this.lockedview = true;
        return;
      }
      this.toastr.error(this.translateService.instant('search.download_request_error'));
    });
  }

  private isDriverDocumentLocked(error: any): boolean {
    if (error?.status === 410) {
      return true;
    }

    const body = error?.error;
    const errorMessage = body instanceof ArrayBuffer
      ? new TextDecoder().decode(body).trim()
      : typeof body === 'string'
        ? body
        : body?.code ?? body?.text ?? body?.error?.code ?? error;

    if (['driver_document_locked', 'driver_document_expired'].includes(errorMessage)) {
      return true;
    }

    return false;
  }

  filterSigned(type: string = '') {
    const filteredDocs = this.pdfs;
    if (filteredDocs.length < this.documents.length) {
      this.toastr.info(this.translateService.instant(`components.${type}.not_signed`));
    }
    return filteredDocs;
  }

  email() {
    const docIds = this.documentsService.getDriverDocIds();
    if(!!docIds.length) {
      this.mailSender.open(true);
    } else {
      this.toastr.info(this.translateService.instant('mail_sender.cannot_send'));
    }
  }

  sendDocs(mails) {
    this.loading = true;
    this.documentsService.emailSend(mails, true).subscribe(data => {
      this.loading = false;
      this.toastr.success(this.translateService.instant('mail_sender.success_send'));
      this.mailSender.close();
    }, err => {
      this.toastr.error(this.translateService.instant(err));
      this.loading = false;
    });
  }

  async print() {
    const pdfs = this.filterSigned('print');
    if (!!!pdfs.length) return;

    this.spinner.show();
    const blob = await this.pdfService.getPdfBlobForPrinting(pdfs);
    this.pdfToPrint = URL.createObjectURL(blob as Blob);
    this.spinner.hide();

    if (this.appService.mobileCheck()) {
      this.toastr.info(this.translateService.instant('components.print.downloading_doc'));
      window.open(this.pdfToPrint);
    }
    else if (typeof window["InstallTrigger"] !== 'undefined') {
      this.pdfViewerOnDemand.pdfSrc = this.pdfToPrint;
      this.pdfViewerOnDemand.refresh();
    }
    else if (window.document['documentMode']) {
      (window.navigator as any).msSaveOrOpenBlob(blob);
    }
    else {
      this.renderer.listen(this.iframe.nativeElement, 'load', (e) => {
        this.iframe.nativeElement.contentWindow.print();
      });
    }
  }

  renderFields(docs) {
    docs.forEach(doc => {
      if (doc.SignType.LocationId === 1 && !!doc?.Signers?.length) {
          if(this.signList.find(x => x.type == 'nominate') == undefined) {
            this.signList.push({ 
              type: "nominate", 
              printName: "",
              isRequiredSign: true, 
              isRequiredPrintName: true,
              showSign: true,
              showPrintName: true
            });
          }
        return;
      }

      var config: any =  {};

      doc.SignType.Fields.forEach(f => {
        var entity = '';
        switch(f.TypeEntity){
          case TypeEntity.DriverSign:
            entity = 'driver'; 
            break;
          case TypeEntity.SignDestiny:
            entity = 'destiny'; 
            break;
        }

        config[entity] = config[entity] || {};
        config[entity].typeEntity = f.TypeEntity;
        
        switch(f.Type){
          case 'text':
            config[entity].isRequiredPrintName = f.Required;
            config[entity].showPrintName = false;
          break;
          case 'img':
            config[entity].isRequiredSign = f.Required;
            config[entity].showSign = true;
          break;
          case 'date':
            config[entity].showDate = false;
          break;
        }
      });
        
      Object.entries(config).forEach((x: Array<any>) => {
        if(this.signList.find(y => y.type.toLowerCase() == x[0].toLowerCase()) == undefined) {
          this.signList.push({ type: x[0], ...x[1] });
        }
      })
      this.signList.sort((a, b) => (a.type > b.type) ? 1 : -1);
    });
  }

  async sendSignedDocs() {
    this.errorDiagnosticService.setMethodName('DriverSignerComponent.sendSignedDocs()');
    if (this.signList.filter(x => x.type == 'nominate').length > 0) {
      await this.checkDocSigners(true);
    }

    const docs = this.pdfs.filter(p => 
      this.documents.filter(d => 
        d.Id === p.docId && 
        !p.signed && !d.isMtc ||
        d.isMtc && !!p['Signers'].find(s => s['Status'].toLowerCase() !== 'signed' && this.authService.compareUsr(s))
        )
    );

    if (docs.length === 0) {
      this.toastr.info(this.translateService.instant('sign.pdf_already_signed'));
      return;
    }

    this.sending = true;
    this.spinner.show();
    this.documentsService.sendSignedDocuments(docs, true).subscribe(data => {
      if (data.err.length > 0) this.toastr.error(this.translateService.instant('sign.pdf_sign_some_errors'));

      if (data.success.length > 0) this.documentsService.markDocumentsSigned(data.success, null, this.pdfs, true).subscribe(data => {
        this.documents = data;
      });

      this.toastr.success(this.translateService.instant('sign.pdf_sign_success'));
      this.postSign = true;
      this.signList = [];
      // Reinicio de datos    
      this.initData();

      this.sending = false;
      this.spinner.hide();
    }, err => {
      this.sending = false;
      this.spinner.hide();
      this.toastr.error(this.translateService.instant('sign.pdf_sign_error'));
    });
  }
}
